// Norrviva — Samples swipe row: real-cart "Add set to cart".
// Adds every member variant to window.theme.cart.store, then opens the cart
// drawer — curated sets behave like a normal add-to-cart; the à-la-carte
// tray (norrviva-samples-builder.js) is part 3's own flow.
// Desktop is a static wrapping grid (no scroll control needed); mobile's
// thumb-swipe carousel is plain CSS scroll-snap and needs no JS either.
document.querySelectorAll('.nvv-samples-swipe').forEach(function (section) {
  section.querySelectorAll('[data-samples-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var ids = (btn.dataset.variantIds || '')
        .split(',')
        .filter(Boolean)
        .map(function (id) { return { id: id, quantity: 1 }; });
      if (!ids.length) return;

      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.adding || 'Adding…';

      window.theme.cart.store
        .getState()
        .add(ids)
        .then(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
          if (window.theme.mfpOpen) window.theme.mfpOpen('cart');
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
    });
  });
});
